import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'api/apiCommon'

import {
  type PostQuestionnaireResponsePayload,
  type Questionnaire,
  type QuestionnaireResults,
  type QuestionnaireResultsPayload,
} from './questionnaires.types'

export const getQuestionnaire = createAsyncThunk(
  'questionnaires/getQuestionnaire',
  async (): Promise<Questionnaire> => {
    return await axios.get<Questionnaire>('/ai-questionnaire')
  },
)

export const getQuestionnaireResults = createAsyncThunk(
  'questionnaires/getQuestionnaireResults',
  async ({ companyId, questionnaireId }: QuestionnaireResultsPayload): Promise<QuestionnaireResults> => {
    return await new Promise((resolve, reject) => {
      axios
        .get<QuestionnaireResults>(`/companies/${companyId}/questionnaires/${questionnaireId}/results`)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          console.error('err: ', err)
          reject(err)
        })
    })
  },
)

export const postQuestionnaireResponse = createAsyncThunk(
  'questionnaires/postQuestionnaireResponse',
  async (payload: PostQuestionnaireResponsePayload): Promise<void> => {
    const { companyId, questionnaireId, questionnaireVersionId, response } = payload
    await axios.post(
      `/companies/${companyId}/questionnaires/${questionnaireId}/versions/${questionnaireVersionId}/response`,
      response,
    )
  },
)
